<template>
  <div
    id="debug-overlay"
    class="debug-overlay"
  >
    <slot />
  </div>
</template>

<style scoped>
.debug-overlay {
  position: fixed;
  inset: 4px;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 9999;
  background-color: transparent;
}
</style>
